<template>
  <base-section id="quienes-somos">
    <base-section-heading
      color="grey lighten-2"
      icon="mdi-hexagon-slice-6"
      title="Quiénes somos"
    />

    <v-container>
      <v-row>
        <v-col
          v-for="card in cards"
          :key="card.title"
          cols="12"
          md="4"
        >
          <base-info-card v-bind="card" />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionAboutOurProduct',

    data: () => ({
      cards: [
        {
          title: 'Profesionalidad',
          subtitle: '“Averigua lo que sabes hacer y hazlo mejor que nadie.” - Jason Goldberg -',
          text: 'Pretendemos alcanzar la excelencia, dando lo mejor de nosotros mismos en nuestros proyectos.',
          callout: '01',
        },
        {
          title: 'Cercanía',
          subtitle: 'La sonrisa es la distancia más corta entre dos personas.',
          text: 'Hacemos las cosas como nos gustaría que nos las hiciesen a nosotros, desde la empatía y buscando la máxima satisfacción de nuestros clientes, ',
          callout: '02',
        },
        {
          title: 'Experiencia',
          subtitle: '“No basta con saber las cosas, es necesario practicarlas.” - Don Bosco -',
          text: 'Llevamos más de 25 años haciendo lo que nos apasiona y seguimos aprendiendo con la ilusión del primer día.',
          callout: '03',
        },
      ],
    }),
  }
</script>
